import type { AdminRole } from '@/lib/api-admin';

export const FAQ_ROUTE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN', 'MD_MANAGER'];
